module.exports = __webpack_public_path__ + "media/images/logos/logomark-8a7d036aca9b58c08528317003d022de.svg";